import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppData, NON_KSEF_DOCUMENT_TYPES } from 'fakturnia-shared';

@Component({
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatCheckboxModule, MatIconModule, MatFormFieldModule, MatSelectModule, FormsModule, MatButtonModule, MatTooltipModule],
  selector: 'app-toggle-form-fields-dialog',
  templateUrl: './toggle-form-fields-dialog.component.html',
  styleUrls: ['./toggle-form-fields-dialog.component.scss']
})
export class ToggleFormFieldsDialogComponent {

  currency = 'PLN'
  documentType = ''
  

  generalFields = {
    issuePlace: {
      text: 'Edytuj pole: miejsce wystawienia',
      informations: 'Miejsce wystawienia zawsze wyświetla się na dokumencie. Jeżeli ta opcja jest zaznaczona masz możliwość edycji tego pola w formularzu.'
    },
    hasReceiver: {
      text: 'Dodaj odbiorcę',
    },
    hasComments: {
      text: 'Dodaj pole na uwagi',
    },
    hasDiscount: {
      text: 'Dodaj pole rabat',
    },
    hasGTU: {
      text: 'Dodaj GTU do pozycji',
    },
    hasPKWiU: {
      text: 'Dodaj PKWiU do pozycji',
    },
    showPKWiU: {
      text: 'Wyświetlaj PKWiU na dokumencie',
      informations: 'Kontroluje, czy kody PKWiU mają być widoczne na wygenerowanych dokumentach. Możesz ewidencjonować kody PKWiU bez wyświetlania ich na fakturach.'
    },
    hasAdditionalPaymentDate: {
      text: 'Dodaj datę płatności',
    },
    hasPaymentDescription: {
      text: 'Dodaj opis płatności',
    },
    showVatExemptionBase: {
      text: 'Podstawa zwolnienia na dokumencie',
      informations: 'Wyświetla podstawę prawną zwolnienia z VAT na dokumencie (wymagane gdy jest pozycja ze stawką "zw")'
    },
    signatures: {
      text: 'Dodaj podpisy osób upoważnionych',
    },
    showKsefQrCode: {
      text: 'Wyświetlaj QR kod KSeF',
      informations: 'Wyświetla QR kod weryfikacji faktury w KSeF na wydruku dokumentu (tylko dla faktur wysłanych do KSeF)',
      ksefOnly: true
    },
    showConvertedAmount: {
      text: 'Wyświetlaj wartość brutto w PLN',
      informations: 'Wyświetla przeliczoną wartość brutto w PLN na fakturach w walutach obcych (na podstawie podanego kursu wymiany)'
    }
  }

  generalToggleableFields = Object.keys(this.generalFields)
  
  generalFieldsToShow = new Set()
 
  
  additionalDateHeaders = AppData.AdditionalDateHeaders
  constructor(
    private dialog: MatDialogRef<ToggleFormFieldsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      if (typeof data != 'undefined') {
        
        if(typeof data.currency != 'undefined') {
          this.currency = data.currency
        }

        if(typeof data.documentType != 'undefined') {
          this.documentType = data.documentType
        }

        if(typeof data.generalFieldsToShow != 'undefined') {
          this.generalFieldsToShow = new Set(data.generalFieldsToShow)
        }
      }
  }

  /**
   * Sprawdza czy pole powinno być widoczne dla danego typu dokumentu
   */
  isFieldVisible(field: string): boolean {
    const fieldConfig = this.generalFields[field];
    if (!fieldConfig) return true;
    
    // Jeśli pole jest tylko dla KSeF, ukryj je dla dokumentów non-KSeF
    if (fieldConfig.ksefOnly && this.documentType && NON_KSEF_DOCUMENT_TYPES.includes(this.documentType)) {
      return false;
    }
    
    return true;
  }


  close() {
    this.dialog.close({
      success: false,
      data: null
    })
  } 

  saveChanges() {

    this.dialog.close({
      success: true,
      data: {
        currency: this.currency,
        generalFieldsToShow: Array.from(this.generalFieldsToShow),

      }
    })
    
  }
  toggleFieldVisibility(type: 'seller' | 'buyer' | 'receiver' | 'general' , field: any) {

    if( type === 'general') {
      this.generalFieldsToShow.has(field) ? this.generalFieldsToShow.delete(field) : this.generalFieldsToShow.add(field)
    }
  }
}
